import { useLayoutEffect } from 'react'
import { useLocation } from 'react-router-dom'

export const resetPageScroll = () => {
  window.scrollTo(0, 0)
  document.documentElement.scrollTop = 0
  document.body.scrollTop = 0

  const scrollContainer = document.getElementById('scroll')
  if (scrollContainer) scrollContainer.scrollTop = 0
}

export default function ScrollToTopOnNavigate() {
  const location = useLocation()

  useLayoutEffect(() => {
    resetPageScroll()
  }, [location.pathname, location.search])

  return null
}
